export default __webpack_public_path__ + "static/logo-3bac0bf87039a72398ead704674290b6.svg";